import { AlchemyProvider } from '@m/alchemy-ui/AlchemyProvider';
import { LoadingIndicator } from '@m/alchemy-ui/LoadingIndicator';
import styled, { css } from 'styled-components';

interface LoadingProps {
  height?: string;
  label?: string;
  fullPage?: boolean;
}

const FullPageLoading = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(250, 250, 250, 0.7);
  z-index: 10;
`;

const LoadingWrapper = styled.div<{ height?: string }>`
  position: relative;
  width: 100%;
  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
`;

const Loading = ({ height, label, fullPage = false, ...restOptions }: LoadingProps) =>
  fullPage ?
    <FullPageLoading>
      <LoadingIndicator label={label} {...restOptions} />
    </FullPageLoading>
  : <LoadingWrapper height={height}>
      <LoadingIndicator label={label} {...restOptions} />
    </LoadingWrapper>;

export const AlchemyLoading = ({
  fullPage = false,
  height,
  ...restOptions
}: {
  fullPage?: boolean;
  height?: string;
}) => (
  <AlchemyProvider>
    <Loading fullPage={fullPage} height={height} {...restOptions} />
  </AlchemyProvider>
);

export default Loading;
